import axios from 'axios';
import {
  API_LOGIN,
  API_ADD_USER,
  API_ADD_USER_GET_LISTS,
  API_TOKEN_INFO,
  API_ALL_USERS,
  API_USER_BY_USERNAME,
  API_UPDATE_USER,
  API_NEW_PASSWORD,
  API_CHANGE_PASSWORD,
  API_LOGOUT
} from "./ServiceAPI";
import ServiceGetInstanceHTTP from "./ServiceGetInstanceHTTP";


class ServiceUser {
  addUser(userObj) {
    return ServiceGetInstanceHTTP.getAxios().post(API_ADD_USER, userObj);
  }

  updateUser(userObj) {
    return ServiceGetInstanceHTTP.getAxios().post(API_UPDATE_USER, userObj);
  }

  getLists() {
    return ServiceGetInstanceHTTP.getAxios().get(API_ADD_USER_GET_LISTS);
  }

  getUser(id) {
    return ServiceGetInstanceHTTP.getAxios().get(API_USER_BY_USERNAME + id)
  }

  getUsers() {
    return ServiceGetInstanceHTTP.getAxios().get(API_ALL_USERS);
  }

  login(credentials) {
    return axios.post(API_LOGIN, credentials);
  }
  changePassword(credentials) {
    return axios.patch(API_CHANGE_PASSWORD, credentials);
  }

  changePasswordV2(credentials) {
    return ServiceGetInstanceHTTP.getAxios().post(API_NEW_PASSWORD, credentials);
  }
  logout() {
    return ServiceGetInstanceHTTP.getAxios().get(API_LOGOUT);
  }
  getRoleByToken() {
        return ServiceGetInstanceHTTP.getAxios().get(API_TOKEN_INFO);
  }
}
  export default new  ServiceUser();
